import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import {
    GetEcshopTradesHistoryRequestModel,
    GetEcshopTradesHistoryResponseModel,
} from "@/features/accounts/ecshop/services/get-trades-history-model";

export class GetEcshopTradesHistoryApi {
    /**
     * EC取込履歴取得API
     */
    public getEcshopTradesHistory = async (
        param: GetEcshopTradesHistoryRequestModel,
    ): Promise<GetEcshopTradesHistoryResponseModel> => {
        const path = `/api/ecshopaccounts/ecshops/tradeshistory`;
        const res = await ApiClient.instance.get<GetEcshopTradesHistoryResponseModel>({
            path: path,
            params: param as NonNullable<unknown>,
        });

        if (res.ok === false) {
            throw MoneyLinkException.fromServer({ response: res });
        }

        return res.body;
    };
}
